import styled from 'styled-components';

export const MediaRow = styled.div`
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 100%;
  /* width: 270px; */
`;

export const DocumentContainer = styled.div`
  padding: 3px 3px 8px;
  box-sizing: border-box;
  width: 276px;
  position: relative;
  z-index: 1;
`;

export const DocumentLink = styled.a`
  border-radius: 6px;
  cursor: pointer;
  box-sizing: border-box;
  color: inherit;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  text-decoration: none;
`;

export const DocumentRow = styled.div`
  padding: 13px 19px;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  text-decoration: none;
`;

export const ExtentionIconContainer = styled.div`
  margin-top: -1px;
  flex: none;
`;

export const ExtentionIcon = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  height: 30px;
  width: 26px;
`;

export const DocumentNameContainer = styled.div`
  margin: 0 10px;
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  top: -2px;
  white-space: nowrap;
`;

export const DocumentName = styled.span`
  display: inline;
  visibility: visible;
`;

export const DownloadIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex: none;
  width: 34px;
  height: 34px;
  color: rgba(51, 51, 51, .5);
`;


export const InfoItemBullet = styled.span`
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 4px;
  display: inline-block;
  color: rgba(0, 0, 0, .25);
`;


export const InfoContainer = styled.div<{textColor?: string}>`
  left: 8px;
  bottom: 3px;
  color: ${props => props.textColor};
  ${InfoItemBullet} {
    color: ${props => props.textColor};

  }
  font-size: 11px;
  height: 15px;
  line-height: 15px;
  position: absolute;
`;

export const InfoItem = styled.span`
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
